/* global axios */

import ApiClient from './ApiClient';

class NaviOsMcpConnectionsAPI extends ApiClient {
  constructor() {
    super('navi_os_mcp_connections', { accountScoped: true });
  }

  rotateToken(id) {
    return axios.post(`${this.url}/${id}/rotate_token`);
  }

  suspend(id) {
    return axios.post(`${this.url}/${id}/suspend`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  approvals(id) {
    return axios.get(`${this.url}/${id}/approvals`);
  }

  approve(id, approvalId) {
    return axios.post(`${this.url}/${id}/approvals/${approvalId}/approve`);
  }

  reject(id, approvalId) {
    return axios.post(`${this.url}/${id}/approvals/${approvalId}/reject`);
  }

  updatePermissions(id, connection) {
    return axios.patch(`${this.url}/${id}`, { connection });
  }
}

export default new NaviOsMcpConnectionsAPI();
